import { render, staticRenderFns } from "./aralmTable.vue?vue&type=template&id=71cbf23e&scoped=true&"
import script from "./aralmTable.vue?vue&type=script&lang=js&"
export * from "./aralmTable.vue?vue&type=script&lang=js&"
import style0 from "./aralmTable.vue?vue&type=style&index=0&id=71cbf23e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cbf23e",
  null
  
)

export default component.exports